export default __webpack_public_path__ + "static/media/100GB.5f4bde10.png";